export const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  return 'desktop';
};

export const getDownloadText = () => {
  const device = detectDevice();

  switch (device) {
    case 'ios':
      return 'Próximamente en App Store';
    case 'android':
      return 'Próximamente en Google Play';
    default:
      return 'Próximamente en App Store y Google Play';
  }
};

export const getDownloadUrl = () => {
  const device = detectDevice();

  switch (device) {
    case 'ios':
      return '#'; // Will be replaced with actual App Store URL
    case 'android':
      return '#'; // Will be replaced with actual Google Play URL
    default:
      return '#';
  }
};